module.exports = __webpack_public_path__ + "c9cd8574c5800bda36d913655f9172cc.svg";